import { render, staticRenderFns } from "./MedicalTechnologyAttention.vue?vue&type=template&id=5f39cce5&"
import script from "./MedicalTechnologyAttention.vue?vue&type=script&lang=js&"
export * from "./MedicalTechnologyAttention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VSlideYTransition})
